import Artifacts from "./Artifacts";
export default Artifacts;
